import { createAPI } from '../../common'

export default {
  preAction: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0f60bdujpot0qsfbdujpo', 'post', config, {
      neverLoading: true
    }),
  postAction: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0f60bdujpot0qptubdujpo', 'get', config, {
      neverLoading: true
    }),
  postE5ListData: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0f60mjtuebub', 'post', config),
}
